module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/photoalbums/bravenet_photo_albums_mobile_friendly.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/photoalbums/bravenet_photo_albums_mobile_friendly.png
// module id = 554N
// module chunks = 0